import 'braid-design-system/reset';
import { BraidProvider, ToastProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { Helmet } from 'react-helmet';
import { ScoobieLinkProvider } from 'scoobie';
import { QueryParamProvider } from 'use-query-params';

import { PreviewDeploymentBannerProvider } from './PreviewDeploymentBanner.tsx';
import { ReactRouter6Adapter } from './ReactRouter6Adapter.tsx';
import { Router } from './Router.tsx';
import { TanstackQueryProvider } from './TanstackQueryProvider.tsx';

import { IncidentToaster } from '#src/components/IncidentToaster/IncidentToaster.tsx';
import { PageErrorBoundary } from '#src/components/PageErrorBoundary/PageErrorBoundary.tsx';
import { TealiumTrackableLink } from '#src/components/TealiumTrackableLink/TealiumTrackableLink.tsx';
import { MdxProvider } from '#src/components/mdx/MdxProvider.tsx';
import { UserProvider } from '#src/hooks/auth.tsx';
import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { GrantsProvider } from '#src/hooks/grants.tsx';
import { NavContextProvider } from '#src/hooks/nav.tsx';
import { StatuspageProvider } from '#src/hooks/statuspage.tsx';
import { TrackingProvider } from '#src/hooks/tracking/TrackingProvider.tsx';
import { ClientErrorPage } from '#src/pages/ClientErrorPage.tsx';
import { OrganizationProvider } from '#src/pages/manage/organizations/OrganizationContext.tsx';

export const App = () => {
  const config = useEnvironmentConfig();

  return (
    <TanstackQueryProvider>
      <UserProvider>
        <OrganizationProvider>
          <TrackingProvider>
            <ScoobieLinkProvider propagateSearchParams={['v', 'v-panel']}>
              <BraidProvider
                linkComponent={TealiumTrackableLink}
                theme={seekJobs}
              >
                <MdxProvider
                  graphqlPlayground={`${config.baseUrls.demi}/manage/graphql-explorer`}
                >
                  <Helmet
                    defaultTitle="SEEK Developer"
                    titleTemplate="%s | SEEK Developer"
                  />
                  <QueryParamProvider adapter={ReactRouter6Adapter}>
                    <GrantsProvider>
                      <StatuspageProvider pageUrl="https://status.seek.com">
                        <ToastProvider>
                          <IncidentToaster />
                          <NavContextProvider>
                            <PreviewDeploymentBannerProvider>
                              <PageErrorBoundary
                                errorPage={<ClientErrorPage />}
                              >
                                <Router />
                              </PageErrorBoundary>
                            </PreviewDeploymentBannerProvider>
                          </NavContextProvider>
                        </ToastProvider>
                      </StatuspageProvider>
                    </GrantsProvider>
                  </QueryParamProvider>
                </MdxProvider>
              </BraidProvider>
            </ScoobieLinkProvider>
          </TrackingProvider>
        </OrganizationProvider>
      </UserProvider>
    </TanstackQueryProvider>
  );
};
